import React, { useState, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import addREC from "../../../../../assets/icons/addREC.svg";
import editIcons from "../../../../../assets/icons/editIcons.svg";
import { Avatar, Drawer } from "@mui/material";
import CompanyDashboardInitiativeDrawerSideBarRolePopup from "./company-dashboard-initiative-drawer-side-bar-role-popup";
import "./company-dashboard-initiative-drawer-side-bar.scss";
import UserDashboardAllObjectiveDrawer from "../../../../user-dashboard/user-dashboard-all-objective-drawer/user-dashboard-all-objective-drawer";

const CompanyDashboardInitiativeDrawerSideBarRole: any = (props: any) => {// NOSONAR
  const {
    selectedAddedRole,
    setSelectedAddedRole,
    employeesList,
    initiativeIdTooltip,
    initiativeId,
    handleCreateInitiative,
    payloadData,
    canEdit,
    canWrite,
    initiativeDataPermissions,
    selectedDepartment,
    setSelectedDepartment,
    selectedRole,
    setSelectedRole,
    setSelectedAddedDepartment,
    selectedAddedDepartment
  } = props;
  const employeeOptions = employeesList?.map((emp: any) => {
    return {
      id: emp?.employeeId,
      name: emp?.employeeFullName,
      label: emp?.employeeFullName,
      profileImage: emp?.employeeImage,
      role: "Owner",
      roleId: emp?.roles?.[0]?.roleId || null,
      departmentId: emp?.departmentId || null,
      departmentName: emp?.departmentName || null,
    };
  });
  const [isShowEditRole, setIsShowEditRole] = useState(false);
  const [Roles, setRoles] = useState(employeeOptions);
  const [isShowUserObjectiveDrawer, setIsShowUserObjectiveDrawer] =
    useState(false);
  const [selectedApprover, setSelectedApprover] = useState<any>(null);
  const [departRoles] = useState<any>(selectedDepartment);

  // Helper function to transform role names for display
  const getDisplayRoleName = (roleName: string | null) => {
    if (!roleName) return null;
    return roleName === "Super Admin" ? "Admin" : roleName;
  };

  const handleRemoveRole = (RoleText: any) => {
    setSelectedRole((prevSelected: any) =>
      prevSelected.filter((dept: any) => dept?.id !== RoleText),
    );
    // }, 50);
  };

  const handleAddRole = (RoleText: any) => {
    if (!selectedRole.includes(RoleText)) {
      setSelectedRole((prevSelected: any) => [
        ...prevSelected,
        { ...RoleText, role: "PM" },
      ]);
      // }, 200);
    }
  };

  const onSearch = (value: any) => {
    if (value) {
      const filteredRoles = [...selectedRole?.sort((a: any, b: any) => a.name.localeCompare(b.name)) || [], ...Roles?.filter((role: any) => !selectedRole.some((selected: any) => selected.id === role.id)) || []].filter((Role: any) =>
        Role.name.toLowerCase().includes(value.toLowerCase()),
      );
      setRoles(filteredRoles);
    } else {
      setRoles( [...selectedRole?.sort((a: any, b: any) => a.name.localeCompare(b.name)) || [], ...employeeOptions?.filter((role: any) => !selectedRole.some((selected: any) => selected.id === role.id)) || []]);
    } 
  };

  useEffect(() => {
    if (initiativeId) {
      setSelectedRole(selectedAddedRole || []);
    } else {
      setSelectedRole([]);
    }
  }, [initiativeId, selectedAddedRole]);

  useEffect(() => {
    if (!isShowEditRole) {
      setRoles(employeeOptions);
      setSelectedRole(selectedAddedRole || []);
    }
  }, [isShowEditRole, selectedAddedRole]);

    useEffect(() => {
      setIsShowUserObjectiveDrawer(false);
    }, [initiativeId]);

  const stringAvatar = (name: string) => {
    return {
      sx: {
        bgcolor: "#403c6f",
      },
      children: `${name?.split(" ")?.[0]?.[0]}${name?.split(" ")?.[1]?.[0]}`,
    };
  };

  let actionIcon: React.ReactNode = null;
  if (initiativeId && selectedAddedRole.length) {
    if (canEdit && initiativeDataPermissions) {
      actionIcon = <img src={editIcons} alt="edit" />;
    } else if (canWrite && initiativeDataPermissions) {
      actionIcon = <img src={addREC} alt="add" />;
    }
  } else if (canWrite && initiativeDataPermissions) {
    actionIcon = <img src={addREC} alt="add" />;
  } else if (canEdit && initiativeDataPermissions) {
    actionIcon = <img src={editIcons} alt="edit" />;
  }

  return (
    <>
      <div className="company-dashboard-initiative-drawer-side-bar-content-header">
        <div>Roles</div>
        <Tooltip title={initiativeIdTooltip}>
          <button
            className="company-dashboard-initiative-drawer-side-bar-content-header-edit-icon"
            onClick={() => {
              if (initiativeId && canEdit) setIsShowEditRole(true);
            }}
            style={{
              cursor:
                !initiativeId || (!canEdit && !canWrite)
                  ? "not-allowed"
                  : "pointer",
            }}
          >
            {actionIcon}
          </button>
        </Tooltip>
      </div>
      {selectedAddedRole.length ? (
        selectedAddedRole.map((role: any, index: number) => (
          <div
            className="company-dashboard-initiative-drawer-side-bar-content-roles"
            key={index + 1}
          >
            <div className="company-dashboard-initiative-drawer-side-bar-content-role-content">
              <div className="company-dashboard-initiative-drawer-side-bar-content-role-content-right">
                <button
                  className="company-dashboard-initiative-drawer-side-bar-content-role-content-right-image"
                  onClick={() => {
                    setSelectedApprover({
                      id: role?.id, // 👈 make sure you have this id in role object
                      name: role?.name,
                    });
                    setIsShowUserObjectiveDrawer(true);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {role?.profileImage ? (
                    <Avatar {...stringAvatar(role?.name)} />
                  ) : (
                    <Avatar alt={role?.name} src={role?.profileImage} />
                  )}
                </button>
                <div className="company-dashboard-initiative-drawer-side-bar-content-role-content-right-label">
                  {role?.name}
                </div>
              </div>
              <div className="company-dashboard-initiative-drawer-side-bar-content-role-content-left">
                {getDisplayRoleName(role?.role)}
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="company-dashboard-initiative-drawer-side-bar-content-roles">
          <div className="company-dashboard-initiative-drawer-side-bar-content-no-role">
            <div className="company-dashboard-initiative-drawer-side-bar-content-no-role-text ">
              No roles have been assigned yet.
            </div>
            {canWrite && initiativeDataPermissions && (
              <Tooltip title={initiativeIdTooltip}>
                <button
                  className="company-dashboard-initiative-drawer-side-bar-content-no-role-button"
                  onClick={() =>
                    initiativeId ? setIsShowEditRole(true) : null
                  }
                  style={{ cursor: initiativeId ? "auto" : "not-allowed" }}
                >
                  Add Roles
                </button>
              </Tooltip>
            )}
          </div>
        </div>
      )}
      <CompanyDashboardInitiativeDrawerSideBarRolePopup
        isShowEditRole={isShowEditRole}
        setIsShowEditRole={setIsShowEditRole}
        onSearch={onSearch}
        Roles={Roles}
        selectedRole={selectedRole}
        handleRemoveRole={handleRemoveRole}
        handleAddRole={handleAddRole}
        setSelectedAddedRole={setSelectedAddedRole}
        handleCreateInitiative={handleCreateInitiative}
        payloadData={payloadData}
        selectedDepartment={selectedDepartment}
        setSelectedAddedDepartment={setSelectedAddedDepartment}
        setSelectedDepartment={setSelectedDepartment}
        departRoles={departRoles}
        setSelectedRole={setSelectedRole}
        selectedAddedDepartment={selectedAddedDepartment}
      />
      <Drawer
        anchor={"bottom"}
        open={isShowUserObjectiveDrawer}
        onClose={(event, reason) => {
          if (reason === "backdropClick") {
            return;
          }
          setIsShowUserObjectiveDrawer(false);
        }}
        slotProps={{
          paper: {
            sx: {
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
              top: "auto", // reset default
              marginTop: "10px", // 👈 space from top - reduced from 40px to 10px
              minHeight: "91.9vh",
              maxHeight: "91.9vh",
            },
          },
        }}
      >
        <UserDashboardAllObjectiveDrawer
          onClose={() => setIsShowUserObjectiveDrawer(false)}
          approverId={selectedApprover?.id}
          setIsShowAllObjectiveDrawer={setIsShowUserObjectiveDrawer}
          // Pass whatever props you need for user-specific dashboard
        />
      </Drawer>
    </>
  );
};

export default CompanyDashboardInitiativeDrawerSideBarRole;
